import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ResourceService {
	apiUrl = environment.serverUrl;

	constructor(private httpClient: HttpClient) {}

	/**
	 * get resources list.
	 */
	public getResourcesList(pageNum:any): Observable<any> {
		return this.httpClient.get(this.apiUrl + 'resources?page=' + pageNum);
	}

	/**
	 * get individual resource
	 */
	public getResourceDetails(resourceId: any): Observable<any> {
		return this.httpClient.get(this.apiUrl + 'resource-detail/' + resourceId);
	}

	/**
	 * get featured resources
	 */
	public getFeaturedResources(): Observable<any> {
		return this.httpClient.get(this.apiUrl + 'featured-resources');
	}

	/**
	 * get latest resources
	 */
	public getLatestResources(): Observable<any> {
		return this.httpClient.get(this.apiUrl + 'latest-resources');
	}
}
